// Import Dependencies
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Local Imports
import { defaultTheme } from "configs/theme.config";

// Translation bundles — bundled at build time, zero network dependency.
// Tolgee is used only via CLI (tolgee push / tolgee pull) for translation sync.
// See docs/I18N_ARCHITECTURE.md §8 for the workflow.
import fr_be from "./locales/fr_be/translations.json";
import en from "./locales/en/translations.json";
import nl_be from "./locales/nl_be/translations.json";

const resources = {
  fr_be: { translation: fr_be },
  fr: { translation: fr_be },
  en: { translation: en },
  nl_be: { translation: nl_be },
  nl: { translation: nl_be },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    fallbackLng: defaultTheme.fallbackLang || "fr_be",
    supportedLngs: ["fr_be", "fr", "nl_be", "nl", "en"],
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    debug: import.meta.env.DEV,
    returnNull: false,
    returnEmptyString: false,
    react: {
      useSuspense: false,
    },
  });

export default i18n;